<template>
  <v-container id="forgot" class="fill-height" tag="section">
    <v-row justify="center">
      <v-form @submit.prevent="reset()">
        <v-slide-y-transition appear>
          <base-material-card
            color="success"
            light
            max-width="100%"
            width="400"
            class="px-5 py-3"
          >
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="display-2 font-weight-bold mb-2">
                  {{ $t("Reset Password") }}
                </h1>
              </div>
            </template>

            <v-card-text class="text-center">
              <p>{{ $t("Insert new Password") }}:</p>
              <v-text-field
                color="secondary"
                :label="$t('Password')+'...'"
                name="password"
                prepend-icon="mdi-password"
                v-model="password"
                data-vv-name="password"
                :error-messages="errors.collect('password')"
              />
              <pages-btn
                large
                color=""
                depressed
                class="v-btn--text success--text"
                type="submit"
              >
                {{ $t("Reset Password Btn") }}
              </pages-btn>
              <v-spacer></v-spacer>
              <br><br>
              <p>
                <a @click="$router.push({ name: 'auth.login' })">
                  {{ $t("Login") }}
                </a>
              </p>
            </v-card-text>
          </base-material-card>
        </v-slide-y-transition>
      </v-form>
    </v-row>
  </v-container>
</template>

<script>
import { resetPassword } from "./shared/services";

export default {
  name: "reset",
  components: {
    PagesBtn: () =>
      import("@/app/shared/components/template/pages/components/Btn")
  },
  $_veeValidate: {
    validator: "new"
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang') || 'de';
    this.$i18n.locale = lang
  },
  data() {
    return {
      password: null
    };
  },
  methods: {
    reset() {
      resetPassword(
        {
          password: this.password,
          email: this.$route.query.email,
          token: this.$route.query.token
        },
        this.$validator
      )
        .then(resp => {
          if (resp.success && resp.message) {
            this.$root.$notification(this.$t(resp.message), {
              type: "success"
            });
          }
          this.$router.push({ name: "auth.login" });
        })
        .catch(resp => {
          this.$root.$notification(resp.data.message, { color: "error" });
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
